import { render, staticRenderFns } from "./PreviousComputations.vue?vue&type=template&id=2999e191&scoped=true&"
import script from "./PreviousComputations.vue?vue&type=script&lang=js&"
export * from "./PreviousComputations.vue?vue&type=script&lang=js&"
import style0 from "./PreviousComputations.vue?vue&type=style&index=0&id=2999e191&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2999e191",
  null
  
)

export default component.exports